import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import pluralize from 'pluralize';
import { Link } from 'react-router-dom';
import ToolTipIcon from '../../../components/ToolTipIcon/ToolTipIcon';
import ToolTip from '../../../components/ToolTipIcon/ToolTip';

function URLRulesetsActions(props) {
  const { removables, getSelectedItems, handleClickDelete, handleClickDuplicate, handleClickAdd } =
    props;
  const {
    auth: {
      user: {
        permissions: { Writer },
      },
    },
  } = props;

  if (!Writer) {
    return [];
  }

  const selectedUrl = getSelectedItems()[0] ? `/url-rulesets/${getSelectedItems()[0].id}` : '';

  return (
    <div
      data-test="url-rulesets-actions"
      className="grid grid-cols-[repeat(5,_max-content)] md:grid-cols-[repeat(7,_max-content)] xl:grid-cols-[repeat(14,_max-content)] gap-2 mt-8"
    >
      <ToolTip className="add-btn" toolText="Add URLRuleset">
        <button
          type="button"
          onClick={handleClickAdd}
          className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
        >
          <img
            src="/assets/images/icons/upload_icon.svg"
            alt="Health Check"
            className="w-[50px] h-[50px]"
            draggable={false}
          />
        </button>
      </ToolTip>
      {removables > 0 && (
        <ToolTipIcon toolText={pluralize('Delete URLRuleset', removables)}>
          <button
            type="button"
            onClick={handleClickDelete}
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/delete_button.svg"
              alt="Delete"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </button>
        </ToolTipIcon>
      )}

      {removables === 1 && (
        <ToolTipIcon toolText="Duplicate URLRuleset">
          <button
            type="button"
            onClick={async () => {
              handleClickDuplicate();
            }}
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/copy_button.svg"
              alt="Copy"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </button>
        </ToolTipIcon>
      )}
      {removables === 1 && (
        <ToolTipIcon toolText="Edit URLRuleset">
          <Link
            to={selectedUrl}
            type="button"
            onClick={async () => {}}
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/pencil_button.svg"
              alt="Edit"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </Link>
        </ToolTipIcon>
      )}
    </div>
  );
}

const mapDispatchToProps = {};
const mapStateToProps = state => ({
  auth: state.auth,
});

URLRulesetsActions.propTypes = {
  removables: PropTypes.number,
  getSelectedItems: PropTypes.func.isRequired,
  handleClickDelete: PropTypes.func.isRequired,
  handleClickDuplicate: PropTypes.func,
  handleClickAdd: PropTypes.func,
  auth: PropTypes.shape({
    user: PropTypes.shape({
      permissions: PropTypes.shape({
        Writer: PropTypes.bool,
      }),
    }),
  }).isRequired,
};

URLRulesetsActions.defaultProps = {
  removables: 0,
  handleClickDuplicate: () => {},
  handleClickAdd: () => {},
};

export default connect(mapStateToProps, mapDispatchToProps)(URLRulesetsActions);
